"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVoiceSample = void 0;
const core_1 = require("@zodios/core");
const zod_1 = require("zod");
exports.getVoiceSample = (0, core_1.makeEndpoint)({
    method: "get",
    path: "/app/voice/:voiceId/sample",
    alias: "getVoiceSample",
    parameters: [
        {
            name: "audioSpeed",
            type: "Query",
            schema: zod_1.z.number().optional(),
        },
    ],
    response: zod_1.z.object({
        url: zod_1.z.string(),
    }),
});
//# sourceMappingURL=getSample.js.map